import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { FaLock } from "react-icons/fa"

import { connect } from "react-redux"
import { Row, Col, Button, Badge, UncontrolledTooltip, Modal } from "reactstrap"
import { Link } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import LockModal from "components/Common/LockModal"

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

import logo from "../../assets/images/logo.svg"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"
import Clock from "pages/Clock/Clock"

const Header = props => {
  const navigate = useNavigate()
  // Function to check and handle auto logout
  const full_name = localStorage.getItem("full_name")
  const password = localStorage.getItem("password")

  const [lockOpen, setLockOpen] = useState(false)

  useEffect(() => {
    if (lockOpen === true) {
      localStorage.setItem("isLocked", "true")
    } else {
      localStorage.setItem("isLocked", "false")
    }
  }, [lockOpen])

  useEffect(() => {
    const loginTime = localStorage.getItem("loginTime")
    const expirationTime = localStorage.getItem("expirationTime")

    const currentTime = new Date().getTime()

    // If login time is found in localStorage
    if (loginTime && expirationTime) {
      if (currentTime > expirationTime) {
        localStorage.removeItem("loginTime")
        localStorage.removeItem("expirationTime")
        navigate("/logout")
      }
    } else {
      navigate("/logout")
    }
  }, [navigate])

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <Row>
          <div className="navbar-header">
            <Col xl={3}>
              <div className="d-flex">
                <div className="navbar-brand-box d-lg-none d-md-block">
                  <Link to="/" className="logo logo-dark">
                    <span className="logo-sm">
                      <img src={logo} alt="" width={30} />
                    </span>
                  </Link>
                  <Link to="/" className="logo logo-light">
                    <span className="logo-sm">
                      <img src={logo} alt="" width={30} />
                    </span>
                  </Link>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    tToggle()
                  }}
                  className="btn btn-sm px-3 font-size-16 header-item "
                  id="vertical-menu-btn"
                  style={styles.menuButton}
                >
                  <i className="fa fa-fw fa-bars" />
                </button>

                {/* <div style={styles.welcomeSection}>
                  <span style={styles.welcomeText}>Welcome,</span>
                  <Badge
                    pill
                    className="badge-soft-primary"
                    style={styles.nameBadge}
                  >
                    {full_name}
                  </Badge>
                </div> */}
              </div>
            </Col>

            <Col xs={12} md={4} lg={3}>
              <div className="mt-3 me-4">
                <Clock />
              </div>
            </Col>

            <Col
              xs={12}
              md={4}
              lg={3}
              className="d-flex align-items-center justify-content-end pe-0"
            >
              <div
                onClick={() => setLockOpen(true)}
                style={styles.lockButton}
                id="lock-123"
              >
                <i className="bx bxs-lock" style={{ fontSize: "18px" }}></i>
                <UncontrolledTooltip placement="left" target="lock-123">
                  Lock Screen
                </UncontrolledTooltip>
              </div>

              <div className="float-end">
                <ProfileMenu />
              </div>
            </Col>
          </div>
        </Row>
      </header>

      <LockModal isOpen={lockOpen} toggle={() => setLockOpen(false)} />
    </React.Fragment>
  )
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

const styles = {
  lockButton: {
    width: "32px",
    height: "32px",
    borderRadius: "15px",
    border: "1px solid #fecaca",
    background: "linear-gradient(135deg, #fff5f5 0%, #ffe4e6 100%)",
    color: "#dc2626",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 8px rgba(239, 68, 68, 0.15)",
  },
  welcomeSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 16px",
    margin: "10px",
    background: "#f8f9fa",
    borderRadius: "10px",
    border: "1px solid #e9ecef",
    boxShadow: "0 2px 8px rgba(102, 126, 234, 0.25)",
  },
  welcomeText: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#6c757d",
    margin: 0,
    whiteSpace: "nowrap",
  },
  nameBadge: {
    padding: "6px 14px",
    fontSize: "13px",
    fontWeight: "600",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#ffffff",
    border: "none",
    boxShadow: "0 2px 8px rgba(102, 126, 234, 0.25)",
  },
  menuButton: {
    width: "40px",
    margin: "15px 5px 15px 30px",
    height: "40px",
    borderRadius: "10px",
    border: "1px solid #e3e6ea",
    background: "#ffffff",
    color: "#495057",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.04)",
  },
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
